import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { path, prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import { useIntegrationHistory, useIMileDetail, useIMileRemove, useIMileUpdate } from '../../hooks'
import IMileIntegrationUpdateForm from '../../components/IMile/IMileIntegrationUpdateForm'

function IMileIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const messages = useMessages()

  const integrationDetail = useIMileDetail(guid)
  const integrationUpdate = useIMileUpdate(guid)
  const integrationRemove = useIMileRemove()

  const title = prop('name', integrationDetail.detail)
  const type = propOr('', 'type', integrationDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const handleSubmit = formValues => {
    const configuration = prop('configuration', formValues)
    const data = {
      ...formValues,
      configuration: {
        ...configuration,
        isTemperature: path(['configuration', 'isTemperature'], formValues) ? '1' : '0'
      },
    }
    return integrationUpdate.update(data)
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })
  }

  const isLoading = (
    integrationDetail.isLoading ||
    integrationUpdate.isLoading
  )

  const handleRemove = () =>
    integrationRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  const configuration = prop('configuration', integrationDetail.detail)
  const isTemperature = prop('isTemperature', configuration)

  return (
    <DashboardLayout
      isLoading={integrationDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <IMileIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={integrationDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={{
          ...integrationDetail.detail,
          configuration: {
            ...configuration,
            isTemperature: isTemperature === '1'
          }
        }}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default IMileIntegrationUpdateContainer
